import { Component, OnInit } from '@angular/core';
import Storage from 'src/app/Models/Base/storage';
import { AppStateService } from 'src/app/Services/AppState/app-state.service';
import { deleteAllCookies, setLocalStorage } from 'npx-arc-ui/utils';
import { ModalComponent } from '../modal/modal.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-modal-lista-empresas',
  templateUrl: './modal-lista-empresas.component.html',
  styleUrls: ['./modal-lista-empresas.component.scss'],
  standalone: true,
  imports: [
    ModalComponent
    , MatInputModule
    , MatFormFieldModule
    , MatProgressSpinnerModule
    , MatTableModule
    , MatIconModule
    , MatPaginatorModule
    , CommonModule
  ]
})
export class ModalListaEmpresasComponent implements OnInit {
  displayedColumns: string[] = ['col1', 'col2'];
  keyword: string = '';
  isLoading = true;
  page = 0;
  itemsPerPage = 5;
  totalItems = 0;

  constructor(public appStateService: AppStateService) {}

  ngOnInit(): void {
    this.onActualizar();
  }

  onActualizar = () =>{
    this.isLoading = true;
    this.appStateService.CompanyServices.GetListEnterpriseManager(this.keyword, this.itemsPerPage, this.page)
      .subscribe({
        next:(({ itemsPerPage, page, totalItems, success }) => {
          if (success) {
            this.itemsPerPage = itemsPerPage;
            this.page = page;
            this.totalItems = totalItems;
          }
          this.isLoading = false;
        })
        ,error: (err) => {
          this.isLoading = false;
        },
      });
  }
  getPaginatorData(event: any){
    this.isLoading = true;
    this.itemsPerPage = event.pageSize;
    this.page = event.pageIndex + 1;
    this.onActualizar()
  }

  onFilter(event: KeyboardEvent) {
    const filterValue = (event.target as HTMLInputElement).value;
    if (!!filterValue.length && event.key === 'Enter')
    {
      this.keyword = filterValue;
      this.onActualizar();
    }
    else if (filterValue.length  === 0 || filterValue === "")
    {
      this.keyword = '';
      this.onActualizar();
    }
  }

  selectEmpresa(company: string, companyName: string) {
    deleteAllCookies();
    setLocalStorage(Storage.COMPANY_NAME, companyName);
    this.appStateService.AccountService.GetCompanyToken(company, 1);
  }
}
